import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=f1ce87bc&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"
import style0 from "./Notices.vue?vue&type=style&index=0&id=f1ce87bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ce87bc",
  null
  
)

export default component.exports